<template>
    <div class="leagueNav">
        <p class="specificNav"
            v-for="(item,index) in leagueNavList"
            :key="index"
            :class="{specificNavBG:thisPath === item.path}"
            @click="goSomePage(item.path)">
            {{item.title}}
        </p>
    </div>
</template>

<script>
export default {
  name: 'leagueNav',
  data () {
    return {
      thisPath: '',
      leagueNavList: [
        {
          title: '服务体系',
          path: '/serveSystem'
        },
        {
          title: '本会介绍',
          path: '/leagueIntroduce'
        },
        {
          title: '本会规则',
          path: '/leagueRule'
        },
        {
          title: '组织机构',
          path: '/organization'
        },
        {
          title: '发展历程',
          path: '/development'
        },
        {
          title: '入会申请',
          path: '/joinLeague'
        }
      ]
    }
  },
  created () {
    this.getThisPath()
  },
  methods: {
    // 加载当前页面路由路径
    getThisPath () {
      this.thisPath = this.$route.path
    },
    // 跳转页面
    goSomePage (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="less">
.leagueNav{
  width: 190px;
  height: 350px;
  background: #FFFFFF;
  box-sizing: border-box;
  padding: 10px 10px 0 24px;
  margin-top: 20px;
  font-size: 20px;
  margin-right: 8px;
  text-align: center;
  .specificNav{
      width: 156px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      margin-top: 10px;
      font-weight: 500;
      cursor: pointer;
  }
}
.specificNavBG{
    background-image: url('~@/assets/user/nav-bg.png');
    color: #fff;
}
</style>
